export default {
  ISOLATION_AGING: 'isolation-aging',
  HISTOGRAM: 'histogram',
};
